import { HtmlHTMLAttributes, RefObject } from "react";
import { cn } from "@util/helpers";

type ProgressBarProps = Pick<
  HtmlHTMLAttributes<HTMLDivElement>,
  "className"
> & {
  barClassname?: string;
  progressBarContainerRef: RefObject<HTMLDivElement>;
  progressBarRef: RefObject<HTMLDivElement>;
};

export default function ProgressBar({
  className,
  barClassname,
  progressBarContainerRef,
  progressBarRef,
}: ProgressBarProps): React.ReactElement {
  return (
    <div
      ref={progressBarContainerRef}
      className={cn(
        "fixed left-0 top-[50px] z-[10000] w-full bg-white",
        className
      )}
    >
      <div
        ref={progressBarRef}
        className={cn(
          "h-[0.125rem] w-0 bg-gray-850 transition-all duration-150",
          barClassname
        )}
      ></div>
    </div>
  );
}
